import * as gfunctions from '../../../js/generalFunctions';

CCL.cartCard = {
  autoload: [
    ['counter', $('body').length > 0],
    ['toggleBundles', $('.bundle-link').length > 0],
    ['toggleEditGuestBeverage', $('.c-cart').length > 0],
    ['toggleEditGuestSnorkel', $('.c-cart').length > 0],
    ['toggleEditGuestxDining', $('.c-cart').length > 0],
    ['toggleEditTime', $('.edit-time-link').length > 0],
    ['toggleEditGuestTimeShorexCart', $('.c-cart').length > 0],
    ['toggleEditGuestAirport', $('.c-cart').length > 0],
    ['toggleCartEditStateroom', $('.c-cart').length > 0],
    ['removeProduct_DiningBtnClick', $('.dining-remove').length > 0],
    ['updateCss', $('.c-edit-guest-beverage').length > 0],
    ['removeProduct_xDiningBtnClick', $('.xdining-remove').length > 0],
    ['cartUpdatesClose', $('.cart-updates-close').length > 0],
    ['bannerClose', $('.banner-close').length > 0]
  ],

  cartUpdatesClose() {
    $('body').on('click', '.cart-updates-close', (event) => {
      $('.cart-updates').fadeOut();
    });
  },

  bannerClose() {
    $('body').on('click', '.banner-close', (event) => {
      $(event.currentTarget).parents('.general-promo-banner').fadeOut();
    });
  },

  toggleEditGuestxDining() {
    $('body').on('click', '.edit-guest-xdining-link', (event) => {
      // $(element).click((event) => {
      event.preventDefault();
      $(event.target).toggleClass('open');
      this.enable_ADA_ForGuests(event.currentTarget);
      const targetElement = $(event.currentTarget).parents('.c-cart-card').find('.cart-edit-stateroom-wrap');
      $(targetElement).slideToggle();
      // });
    });
  },

  removeProduct_xDiningBtnClick() {
    $('body').on('click', '.xdining-remove', (e) => {
      const productId = $(e.currentTarget).attr('data-productId');
      const serviceTimeSlot = $(e.currentTarget).data('servicetimeslot');
      const buyerId = $(e.currentTarget).data('buyerid');
      const getProductDiv = `.card-${productId}-${serviceTimeSlot}-${buyerId}`;
      $(getProductDiv).css('display', 'none');
      this.removeBtn_xDining_CartAjax(productId, serviceTimeSlot, buyerId);
    });
  },

  removeBtn_xDining_CartAjax(productId, serviceTimeSlot, buyerId) {
    gfunctions.showLoader();
    const jsonObjects = { productId, serviceTimeSlot, buyerId };
    const token = $('#csrfSessionToken').data('csrf');
    const getProductDiv = `.card-${productId}-${serviceTimeSlot}-${buyerId}`;
    $.ajax({
      type: 'POST',
      contentType: 'application/json',
      url: '/shop/cart/entry/execute-action/REMOVE',
      data: JSON.stringify(jsonObjects),
      dataType: 'json',
      beforeSend: (xhr) => {
        xhr.setRequestHeader('CSRFToken', token);
      },
      success: (res) => {
        if (res.removeSuccess) {
          // Update the cart alert message also and remove this product from alert msg
          $(`.cart-updates #cart-alert-${productId}-${serviceTimeSlot}-${buyerId}`).remove();
          const msgLength = $('.cart-updates .unavailable-item').length;
          $('.cart-updates .available').html(`${msgLength} item(s) in your cart has a conflict that needs to be resolved before you can proceed to checkout.`);
          if (msgLength === 0) {
            $('.cart-updates').remove();
          }

          gfunctions.updateCartSummary(res.orderSummary);
          gfunctions.updateProductSummary(res.orderSummary);
          gfunctions.updateHeaderCartWidget(res);
          if (res.cartEmpty) {
            window.location.reload();
          }
          // update cart carousel
          if ($('body').find('.cart-carousel').length) {
            // update cart carousel
            CCL.cartCard.updateCartCarousel();
          }
          console.log(`Something went well on Remove Click for Dining product ${productId}`);
        } else {
          gfunctions.updateCartSummary(res.orderSummary);
          gfunctions.updateProductSummary(res.orderSummary);
          gfunctions.updateHeaderCartWidget(res);
          if (res.cartEmpty) {
            window.location.reload();
          }
          $(`${getProductDiv}`).css('display', 'block'); // Keep the card from DOM if RemoveSuccess is false
        }
        gfunctions.hideLoader();
      },
      error: (error) => {
        gfunctions.hideLoader();
        console.log(`Something went wrong on Remove Click for Dining product ${productId}`);
      }
    });
  },

  counter() {
    /* eslint-disable */
    $('body').on('click keypress', '.increment-btn', (event) => {
      if ((event.which === 13 || event.which === 1) && ($(event.target).hasClass('disabled') || $(event.target).attr('disabled'))) {
        if ($(event.target).hasClass('ada-disabled')) {
          event.preventDefault();
          event.stopPropagation();
          return false;
        }
        $(event.target).addClass('ada-disabled');
      }
      if ($(event.target).hasClass('cart-qty-increment-btn') && $(event.target).attr('disabled')) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
      event.preventDefault();
      const targetElement = $(event.target).parents('.quantity-btn-wrap').find('.quantity-input');
      let quantity = $(targetElement).val();
      quantity++;
      if ($(event.target).parents('.quantity-btn-wrap').find('.decrement-btn').attr('disabled')) {
        $(event.target).parents('.quantity-btn-wrap').find('.decrement-btn').removeAttr('disabled');
      }
      $(targetElement).val(quantity);
      $(targetElement).attr('aria-label', `quantity value is ${quantity}`);
      $(event.currentTarget).attr('aria-label', `increment quantity with current value ${quantity}`);
      console.log(event.currentTarget);
      $(event.target).parents('.quantity-btn-wrap').find('.decrement-btn').attr('aria-label', `decrement quantity with current value ${quantity}`);
      setTimeout(() => {
        $(event.target).focus();
        $(event.target).addClass('ada-element-focus');
      }, 400);
      if (quantity > 1) {
        $('.decrement-btn').removeClass('disabled');
      }
    });
    /* eslint-enable */
    $('body').on('click keypress', '.decrement-btn', (event) => {
      event.preventDefault();
      $('.increment-btn').removeClass('ada-disabled');
      const targetElement = $(event.target).parents('.quantity-btn-wrap').find('.quantity-input');
      let quantity = $(targetElement).val();
      if (quantity > 1) {
        quantity--;
      }
      $(targetElement).val(quantity);
      $(targetElement).attr('aria-label', `quantity value is ${quantity}`);
      $(event.currentTarget).attr('aria-label', `decrement quantity with current value ${quantity}`);
      $(event.target).parents('.quantity-btn-wrap').find('.increment-btn').attr('aria-label', `increment quantity with current value ${quantity}`);
      if (quantity === 0 || quantity === 1 || quantity === '1') {
        $(event.target).parents('.quantity-btn-wrap').find('.decrement-btn').attr('disabled', 'disabled');
      }
      setTimeout(() => {
        $(event.target).focus();
        $(event.target).addClass('ada-element-focus');
      }, 400);
      $('.decrement-btn').addClass('disabled');
      if (quantity > 1) {
        $('.decrement-btn').removeClass('disabled');
      }
      if ($(event.target).parents('.quantity-btn-wrap').find('.quantity-input').val() === '1') {
        $(event.target).parents('.quantity-btn-wrap').find('.decrement-btn').attr('disabled', 'disabled');
      }
    });

    $('body').on('click', '.cart-qty-increment-btn:not(.wishlist-increment-btn)', (event) => {
      const qty = $(event.currentTarget).prev().val();
      const productId = event.currentTarget.dataset.productid;
      this.ajaxForCartQty(qty, productId, event);
    });

    $('body').on('click', '.cart-qty-decrement-btn:not(.wishlist-decrement-btn)', (event) => {
      const qty = $(event.currentTarget).next().val();
      const productId = event.currentTarget.dataset.productid;
      this.ajaxForCartQty(qty, productId, event);
    });

    $('body').on('click', '.wishlist-decrement-btn', (event) => {
      const qty = $(event.currentTarget).next().val();
      const productId = event.currentTarget.dataset.productid;
      this.ajaxForWishListUpdate(qty, productId);
    });

    $('body').on('click', '.wishlist-increment-btn', (event) => {
      const qty = $(event.currentTarget).prev().val();
      const productId = event.currentTarget.dataset.productid;
      this.ajaxForWishListUpdate(qty, productId);
    });

    $('body').on('click', '.wishListEditCartStateroom', (event) => {
      const parentElement = $(event.currentTarget).parents('.cart-edit-stateroom-wrap');
      const productId = parentElement[0].dataset.productid;
      const bookingIdsArray = [];
      const guestIdsArray = [];
      let qty = 0;
      if ($('.c-cart').find(`#cart-edit-${productId} .custom-checkbox .parent-check`).length) {
        $('.c-cart').find(`#cart-edit-${productId} .custom-checkbox .parent-check:checked`).not(':disabled').each((index, element) => {
          if (element.hasAttribute('data-bookingid')) {
            bookingIdsArray.push(element.getAttribute('data-bookingid'));
          }
        });
      }
      if ($('.c-cart').find(`#cart-edit-${productId} .custom-checkbox .guests-check input[type="checkbox"]`).length) {
        $('.c-cart').find(`#cart-edit-${productId} .custom-checkbox .guests-check input[type="checkbox"]:checked`).not(':disabled').each((i, elem) => {
          if (elem.hasAttribute('data-guestid') && !$(elem).prop('disabled')) {
            guestIdsArray.push(elem.getAttribute('data-guestid'));
          }
        });
      }

      if ($('#saveForLaterCartSection').find(`.card-${productId} .cart-card-body .wishlistqty`).length) {
        qty = $('#saveForLaterCartSection').find(`.card-${productId} .cart-card-body .wishlistqty`).val();
      }

      this.ajaxForWishListUpdate(qty, productId, bookingIdsArray, guestIdsArray);
    });

    $('body').on('click', '.wishlistSaveEditGuest_ShoreEx', (e) => {
      const productId = $(e.currentTarget).attr('data-productId');
      const parentElement = $(e.currentTarget).parents('.edit-guest-time-shorex-cart-wrap');
      const changedDiv = `.guest_${productId} .custom-checkbox`;
      const selecteditems = [];
      $(changedDiv).each((index, val) => {
        $(val).find('input:checked').each((i, ob) => {
          selecteditems.push(val.id);
        });
      });
      const shoreExData = gfunctions.getSelectedGuests(selecteditems);

      this.ajaxForWishListUpdate(0, productId, [], [], shoreExData);
    });

    $('body').on('click', '.moveToCart_ShoreEx', (e) => {
      const productId = $(e.currentTarget).attr('data-productid');
      const changedDiv = `.guest_${productId} .custom-checkbox`;
      const selecteditems = [];
      $('body').find(changedDiv).each((index, val) => {
        $(val).find('input:checked').each((i, ob) => {
          selecteditems.push(val.id);
        });
      });

      const productCard = gfunctions.getSelectedGuests(selecteditems);
      this.wishListMoveToCart(0, productId, [], [], productCard);
    });

    $('body').on('click', '.moveToCart_FunShop', (e) => {
      const productId = $(e.currentTarget).attr('data-productid');
      const productType = $(e.currentTarget).attr('data-producttype');
      let qty = 1;
      let sfDataObj = {};
      if ($(e.currentTarget).parents('.c-cart-card').find('.quantity-input').length) {
        qty = $(e.currentTarget).parents('.c-cart-card').find('.quantity-input').val();
      } else if ($(e.currentTarget).parents('.c-cart-card').find('.quantity-input-1').length) {
        qty = $(e.currentTarget).parents('.c-cart-card').find('.quantity-input-1').val();
      }

      if (productType === 'SF' || productType === 'SFP' || productType === 'SFAP') {
        sfDataObj = JSON.parse(CCL.pdpSfPackage.bookingData(productId, e, $(e.currentTarget)));
        $.each(sfDataObj.bookings, (id, value) => {
          value.qty = qty;
        });
        sfDataObj = JSON.stringify(sfDataObj);
      }
      const selecteditems = [];
      const bookingIdsArray = [];
      const guestIdsArray = [];
      $(`#cart-edit-${productId} .custom-checkbox input[type="checkbox"]:checked`).each((index, element) => {
        if (element.hasAttribute('data-bookingid')) {
          bookingIdsArray.push(element.getAttribute('data-bookingid'));
          if (productType === 'SF') {
            const requestObject = JSON.parse(sfDataObj);
            $.each(requestObject.bookings, (id, value) => {
              if (element.getAttribute('data-bookingid') === value.bookingId && element.hasAttribute('data-qtyadded')) {
                value.qty = Number(element.getAttribute('data-qtyadded')) <= 2 ? Number(element.getAttribute('data-qtyadded')) : 2;
              }
            });
            sfDataObj = JSON.stringify(requestObject);
          }
        }
      });

      if ($(`#cart-edit-${productId} .custom-checkbox .guests-check input[type="checkbox"]`).length) {
        $(`#cart-edit-${productId} .custom-checkbox .guests-check input[type="checkbox"]:checked`).each((i, elem) => {
          if (elem.hasAttribute('data-guestid') && !$(elem).prop('disabled')) {
            guestIdsArray.push(elem.getAttribute('data-guestid'));
          }
        });
      }

      let parentProductCode = null;
      if (productType === 'BUBBLES') {
        parentProductCode = $(e.currentTarget).attr('data-parentcode');
      }

      this.wishListMoveToCart(qty, productId, bookingIdsArray, guestIdsArray, null, productType, parentProductCode, sfDataObj);
    });
  },

  wishListMoveToCart(quantity = 1, productId, bookingIdsArray = [], guestIdsArray = [], shoreExproductData = null, productType = null, parentProductCode, sfDataObj = null) {
    let ajaxType = 'application/json';
    gfunctions.showLoader();
    let ajaxUrl = '';
    const token = $('#csrfSessionToken').data('csrf');
    let dataObj = {};

    if (productType === 'CHEERS' || productType === 'BUBBLES' || productType === 'FS' || productType === 'FSV' || productType === 'INTERNET' || productType === 'FTF') {
      ajaxUrl = '/shop/cart/add';
      ajaxType = 'application/x-www-form-urlencoded; charset=UTF-8';
      dataObj.CSRFToken = token;
      dataObj.productCodePost = productType === 'BUBBLES' ? parentProductCode : productId;
      dataObj.qty = quantity > 0 ? quantity : 1;
      dataObj.bookingIds = bookingIdsArray.length ? bookingIdsArray : [];
      dataObj.guestIds = guestIdsArray.length ? guestIdsArray : [];
    } else if (productType === 'SF' || productType === 'SFP' || productType === 'SFAP') {
      ajaxUrl = '/shop/cart/specialFS/add';
      dataObj = sfDataObj;
    } else if (shoreExproductData) {
      dataObj.productCard = shoreExproductData;
      dataObj.productId = productId;
      dataObj.wishList2Entry = true;
      ajaxUrl = '/shop/cart/shoreex/updateSelection';
      dataObj = JSON.stringify(dataObj);
    }

    $.ajax({
      type: 'POST',
      url: ajaxUrl,
      contentType: ajaxType,
      headers: {
        CSRFToken: token
      },
      data: dataObj
    }).done((response) => {
      // remove product from save for later section
      if (response.qtyAdded || response.addedToCart) {
        $(`#saveForLaterCartSection .btn-remove-from-cart.btn-${productId}`).addClass('backToCart').trigger('click');
        // if cart is empty then reload the cart page to get order summary section
        if ($('.cart-entries').length) {
          setTimeout(() => { this.loadCartSection(); }, 500);
          this.updateCartCarousel();
        } else {
          window.location.reload();
        }
      }
      gfunctions.hideLoader();
    }).fail(() => {
      gfunctions.hideLoader();
    });
  },

  loadCartSection(fbt = false) {
    const ajaxUrl = fbt ? '/shop/cart' : '/shop/cart?ajax=true';
    gfunctions.showLoader();
    $.ajax({
      type: 'GET',
      url: ajaxUrl,
      contentType: 'text/html'
    }).done((response) => {
      // Update cart section
      const responseHtml = response;
      const cartEntries = $(`<div> ${responseHtml}</div>`).find('.cart-entries').html();
      $('.cart-entries').empty().html(cartEntries);
      CCL.editCartStateroom.createStateroomHtml();
      gfunctions.hideLoader();
    }).fail(() => {
      gfunctions.hideLoader();
    });
  },

  shoreExLoadWishlist() {
    if ($('body').find('.moveToCart_ShoreEx').length) {
      $('body').find('.moveToCart_ShoreEx').each((index, val) => {
        const productId = $(val).attr('data-productid');
        CCL.guestEditConflicts.cancel_addToCartAjax(productId, true);
      });
    }
  },

  ajaxForWishListUpdate(quantity = 0, productId, bookingIdsArray = [], guestIdsArray = [], shoreExproductData = null) {
    gfunctions.showLoader();
    const token = $('#csrfSessionToken').data('csrf');
    const dataObj = {
      qty: quantity,
      productCode: productId,
      encryptedGuestIds: guestIdsArray,
      encryptedBookingIds: bookingIdsArray,
      variantInfo: shoreExproductData
    };
    $.ajax({
      type: 'POST',
      url: '/shop/cart/update/wishlist',
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      },
      data: JSON.stringify(dataObj)
    }).done((response) => {
      // Update complate save for later section directly
      if (response.updateSuccess) {
        CCL.saveForLaterObj.loadSaveForLaterCartSection();
      }
      gfunctions.hideLoader();
      console.log('QTY update from cart ajax success');
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('QTY update from cart ajax error');
    });
  },

  cartCruiseCashRestrictUser() {
    gfunctions.ajaxForCruiseCashCartAmount().then(() => {
      $('body').find('.cruise-cash-cart-price').each((index, element) => {
        $(element).parents('.cart-card-body').find('.cart-qty-increment-btn').removeAttr('disabled');
        if (Number($(element).parents('.cart-card-body').find('.base-price').data('baseprice')) + Number(localStorage.getItem('cruisecashcartamount')) > 500) {
          $(element).parents('.cart-card-body').find('.cart-qty-increment-btn').attr('disabled', 'disabled');
        }
      });
    });
  },

  ajaxForCartQty(quantity, productId, event) {
    gfunctions.showLoader();
    const token = $('#csrfSessionToken').data('csrf');
    const dataObj = {
      quantity,
      productId
    };
    $.ajax({
      type: 'POST',
      url: '/shop/cart/update/quantity',
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      },
      data: JSON.stringify(dataObj)
    }).done((response) => {
      const { orderSummary } = response;
      if ($(event.target).hasClass('cruise-cash-qty-increment-btn') || $(event.target).hasClass('cruise-cash-qty-decrement-btn')) {
        this.cartCruiseCashRestrictUser();
        CCL.saveForLaterObj.loadSaveForLaterCartSection();
      }
      gfunctions.updateCartSummary(orderSummary);
      gfunctions.updateProductSummary(orderSummary);
      gfunctions.updateCouponSummary(response);
      gfunctions.hideLoader();
      console.log('QTY update from cart ajax success');
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('QTY update from cart ajax error');
    });
  },

  toggleBundles() {
    $('.bundle-link').each((index, element) => {
      $(element).click((event) => {
        event.preventDefault();
        $(element).toggleClass('open');
        this.enable_ADA_ForGuests(element);
        const targetElement = $(event.target).parents('.c-cart-card').find('.bundle-card-wrap');
        $(targetElement).slideToggle();
      });
    });
  },
  toggleEditGuestBeverage() {
    $('.edit-guest-beverage-link').each((index, element) => {
      $(element).click((event) => {
        event.preventDefault();
        $(element).toggleClass('open');
        this.enable_ADA_ForGuests(element);
        const targetElement = $(event.target).parents('.c-cart-card').find('.edit-guest-beverage-wrap');
        $(targetElement).slideToggle();
      });
    });
  },
  toggleEditGuestSnorkel() {
    $('.edit-guest-snorkel-link').each((index, element) => {
      $(element).click((event) => {
        event.preventDefault();
        $(element).toggleClass('open');
        this.enable_ADA_ForGuests(element);
        const targetElement = $(event.target).parents('.c-cart-card').find('.edit-guest-snorkel-wrap');
        $(targetElement).slideToggle();
      });
    });
  },
  toggleEditTime() {
    $('.edit-time-link').each((index, element) => {
      $(element).click((event) => {
        event.preventDefault();
        $(element).toggleClass('open');
        this.enable_ADA_ForGuests(element);
        const targetElement = $(event.target).parents('.c-cart-card').find('.edit-time-wrap');
        $(targetElement).slideToggle();
      });
    });
  },
  toggleEditGuestTimeShorexCart() {
    // $('.edit-guest-time-shorex-cart-link').each((index, element) => {
    $('body').on('click', '.edit-guest-time-shorex-cart-link', (event) => {
      event.preventDefault();
      $(event.target).parents('.c-cart-card').find('.edit-guest-time-shorex-cart-link').toggleClass('open');
      this.enable_ADA_ForGuests(event.target);
      const targetElement = $(event.target).parents('.c-cart-card').find('.edit-guest-time-shorex-cart-wrap');
      $(targetElement).slideToggle();

      if (event.target.dataset.wishlist2entry === 'true' && event.target.dataset.productcode) {
        CCL.guestEditConflicts.cancel_addToCartAjax(event.target.dataset.productcode, event.target.dataset.wishlist2entry);
      }
    });
    // });
  },
  toggleEditGuestAirport() {
    $('.edit-guest-airport-transfers-link').each((index, element) => {
      $(element).click((event) => {
        event.preventDefault();
        $(element).toggleClass('open');
        this.enable_ADA_ForGuests(element);
        const targetElement = $(event.target).parents('.c-cart-card').find('.edit-guest-airport-transfers-wrap');
        $(targetElement).slideToggle();
      });
    });
  },

  toggleCartEditStateroom() {
    $('body').on('click', '.cart-edit-stateroom-link', (event) => {
      event.preventDefault();
      $('body').find('.cart-edit-stateroom-link').toggleClass('open');
      this.enable_ADA_ForGuests(event.currentTarget);
      const targetElement = $(event.target).parents('.c-cart-card').find('.cart-edit-stateroom-wrap');
      $(targetElement).slideToggle();
    });
  },

  removeProduct_DiningBtnClick() {
    $('body').on('click', '.dining-remove', (e) => {
      console.log('hi');
      const productId = $(e.currentTarget).attr('data-productId');
      const variantId = $(e.currentTarget).attr('data-variantid');
      const getProductDiv = `.card-${variantId}`;
      $(getProductDiv).css('display', 'none');
      this.removeBtn_Dining_CartAjax(productId, variantId);
    });
  },

  enable_ADA_ForGuests(element) {
    const ariaExpanded = $(element).attr('aria-expanded');
    if (ariaExpanded === 'false') {
      $(element).attr('aria-expanded', 'true');
    } else {
      $(element).attr('aria-expanded', 'false');
    }
  },

  removeBtn_Dining_CartAjax(productId, variantId) {
    gfunctions.showLoader();
    const jsonObjects = { productId, variantCode: variantId };
    const token = $('#csrfSessionToken').data('csrf');
    $.ajax({
      type: 'POST',
      contentType: 'application/json',
      url: '/shop/cart/dining/removeBaseProduct',
      data: JSON.stringify(jsonObjects),
      dataType: 'json',
      beforeSend: (xhr) => {
        xhr.setRequestHeader('CSRFToken', token);
      },
      success: (res) => {
        if (res.removeSuccess) {
          gfunctions.updateCartSummary(res.orderSummary);
          gfunctions.updateProductSummary(res.orderSummary);
          gfunctions.updateHeaderCartWidget(res);
          // SAS Event for remove
          gfunctions.sasEvents('send', res.cclSasAnalyticsJsonData);
          if (res.cartEmpty) {
            window.location.reload();
          }
          // update cart carousel
          if ($('body').find('.cart-carousel').length) {
            // update cart carousel
            CCL.cartCard.updateCartCarousel();
          }
          console.log(`Something went well on Remove Click for Dining product ${productId} `);
        } else {
          gfunctions.updateCartSummary(res.orderSummary);
          gfunctions.updateProductSummary(res.orderSummary);
          gfunctions.updateHeaderCartWidget(res);
          if (res.cartEmpty) {
            window.location.reload();
          }
          $(`.card-${variantId}`).css('display', 'block'); // Keep the card from DOM if RemoveSuccess is false
        }
        gfunctions.hideLoader();
      },
      error: (error) => {
        gfunctions.hideLoader();
        console.log(`Something went wrong on Remove Click for Dining product ${productId} `);
      }
    });
  },

  updateCss() {
    $('.c-edit-guest-beverage .stateroom').last().css('border-bottom', 'none');
  },

  updateCartCarousel() {
    const token = $('#csrfSessionToken').data('csrf');
    const componentUid = $('body').find('.cart-carousel #componentUid').data('componentuid');
    $.ajax({
      type: 'GET',
      url: `/shop/view/CCLProductCarouselComponentController?componentUid=${componentUid}`,
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      }
    }).done((response) => {
      gfunctions.hideLoader();
      $('body').find('.cart-carousel').replaceWith(response);
      $('body').find('.cart-carousel .empty-placeholder').hide();
      $('body').find('.cart-carousel .product-carousel-container').show();
      CCL.cruiseManager.carouselFunctions();
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('error while fetching data');
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-cart-card/cart-card.js